import { render, staticRenderFns } from "./TreeTable.vue?vue&type=template&id=b56a398c&"
import script from "./TreeTable.vue?vue&type=script&lang=js&"
export * from "./TreeTable.vue?vue&type=script&lang=js&"
import style0 from "./TreeTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports